module.exports.CONSOLE_VERSION = '6.10.0.8'
module.exports.WI_CONSOLE_VERSION = '1.3.0.152'
